import { render, staticRenderFns } from "./l-bubbles.vue?vue&type=template&id=674d9d06&scoped=true"
import script from "./l-bubbles.vue?vue&type=script&lang=js"
export * from "./l-bubbles.vue?vue&type=script&lang=js"
import style0 from "./l-bubbles.vue?vue&type=style&index=0&id=674d9d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d9d06",
  null
  
)

export default component.exports